<template>
  <textarea 
    ref="broadcastchatinput" 
    rows="1" 
    :value="value"
    v-on:input="updateValue($event.target.value)"
    @keydown.enter.exact.prevent
    @keyup.enter.exact="sendMessage($event)"
    @keydown.enter.shift.exact="newline"
    aria-label="Broadcast Message Input"
    tabindex="0"
  >
  </textarea>
</template>

<script>

export default {
  props: ["value"],
  data: function () {
    return {
      inputText: this.value
    }
  },

  methods: {
    resizeTextarea() {
      if(!this.value) this.resetTextarea();
      else 
      this.$refs.broadcastchatinput.style.height = "auto";
      this.$refs.broadcastchatinput.style.height = this.$refs.broadcastchatinput.scrollHeight + "px";
    },
    
    resetTextarea() {
      // this.$el.style.height = "auto";
      this.$nextTick(() => {
        this.$el.setAttribute(
          "style",
          "height: auto"
        );
      });
    },
  
    newline () {
    },
    
    sendMessage (event) {
      if (event.shiftKey) return
      event.preventDefault()
      this.$emit('broadcast-chat-message')
    },
    
    updateValue (value) {
      this.$emit('input', value)
    },
  },

  watch: {
    value (val) {
      this.resizeTextarea()
    }
  }
};
</script>